/**
 * What the signed-in admin's role allows (D77). The API checks every request on its own; the
 * panel only uses this to hide pages and buttons the role can't use.
 */
import type { AdminPermission } from "@custos/core";
import { useAdminMe } from "./queries";

export function useCan(): (...perms: AdminPermission[]) => boolean {
  const me = useAdminMe();
  const granted = me.data?.permissions ?? [];
  return (...perms) => perms.some((p) => granted.includes(p));
}

/** Text shown where an owner-only control would be. */
export const OWNER_ONLY_NOTE = "Only the Owner can do this.";
